import { Injectable } from '@angular/core';
import { ParentApiService } from './parent-api-service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateDocRequestDto } from '../entities/doc-entities/create-doc-request-dto';
import { SigneeDto } from '../entities/doc-entities/signee-dto';
import { CompanyDto } from '../entities/doc-entities/company-dto';
import { CeoDto } from '../entities/doc-entities/ceo-dto';
import { CreateDocFailedResponseDto } from '../entities/doc-entities/create-doc-failed-response-dto';
import { CreateDocTdRequestDto } from '../entities/doc-entities/create-doc-td-request';

export interface DocWizardData {
  manufacturers: CompanyDto[];
  representatives: CompanyDto[];
  ceos: CeoDto[];
  signers: SigneeDto[];
}

@Injectable({
  providedIn: 'root',
})
export class DocApiService extends ParentApiService {
  private readonly baseUrl = environment.webApiAddress + '/api';

  constructor(private readonly http: HttpClient) {
    super();
  }

  getDocProblemsForUnits(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<CreateDocFailedResponseDto[]> {
    return this.http.post<CreateDocFailedResponseDto[]>(`${this.baseUrl}/packaging-units/doc/problem-information`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
    });
  }

  getDocProblemsForSystems(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<CreateDocFailedResponseDto[]> {
    return this.http.post<CreateDocFailedResponseDto[]>(`${this.baseUrl}/packaging-systems/doc/problem-information`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
    });
  }

  generateTechnicalDocumentationForUnits(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-units/generate-technical-documentation`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  generateTechnicalDocumentationForSystems(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-systems/generate-technical-documentation`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  generateDocForUnits(request: CreateDocRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-units/generate-doc`, request, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  generateDocForSystems(request: CreateDocRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-systems/generate-doc`, request, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }
}
